<nav class="stepper" [attr.aria-label]="'register.steps.ariaLabel' | translate">
    <ol>
        <li *ngFor="let key of steps; let i = index"
            [class.done]="i + 1 < current"
            [class.current]="i + 1 === current">
            <button type="button" class="step" (click)="select(i + 1)" [disabled]="i + 1 >= current"
                [attr.aria-current]="i + 1 === current ? 'step' : null">
                <span class="dot" aria-hidden="true">
                    <svg *ngIf="i + 1 < current" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                    <ng-container *ngIf="i + 1 >= current">{{ i + 1 }}</ng-container>
                </span>
                <span class="label">{{ key | translate }}</span>
            </button>
        </li>
    </ol>

    <!-- Phones: the names don't fit under the dots, so the current one is written out -->
    <p class="stepper-summary">
        <strong>{{ 'register.steps.progress' | translate: { n: current, total: steps.length } }}</strong>
        · {{ steps[current - 1] | translate }}
    </p>
</nav>
